<template>
  <div class="d d_xm">
    <headers :goBack="goBack" />
    <template v-if="list.length > 0">
      <div v-for="item in list" :key="item.id">
        <train-item
          :list="item.list"
          :formId="item.formId"
          :id="item.id"
          :status="item.status"
          :handlerDel="handlerDel"
        />
      </div>
      <!-- <div class="addc" v-if="list.length > 0">
        <van-button class="add" @click="add">添加</van-button>
      </div> -->
    </template>
    <template v-else>
      <van-empty description="暂无相关数据" />
    </template>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted } from "vue";
import headers from "@/components/Header";
import trainItem from "@/components/TrainItem.vue";
import { useRoute, useRouter } from "vue-router";
import { getLocal } from "@/common/js";
import { getByFormIdInfo, delForm } from "@/service/form";
import { yORn, trainLevelList, organizerList } from "@/common/js/field";
import { Dialog, Toast } from "vant";
export default {
  name: "detailForm4",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      list: [],
      id: null,
      status: 0,
    });
    onMounted(async () => {
      getList();
    });
    const getList = async () => {
      const { id } = route.query;
      const { code, data } = await getByFormIdInfo({ fid: id });
      if (code === 10000 && data) {
        state.list = data;
        state.id = data.id;
      }
    };
    const handlerDel = (formId, id) => {
      Dialog.alert({
        message: "信息删除后，不可恢复。确定要删除吗？",
      }).then(async () => {
        const res = await delForm({ fid: formId, dataId: id });
        const { code } = res;
        if (code === 10000) {
          state.list = []
          getList();
          Toast.fail("删除成功");
        }
      });
    };

    const goBack = () => {
      router.go(-1);
    };
    const add = async () => {
      const role = await getLocal("dsj_roleId");
      let url = `/info/add/form4`;
      if (role == 6) {
        url = `/info/add/form3`;
      }

      router.push({ path: url, query: { isTrain: true } });
    };

    return {
      ...toRefs(state),
      yORn,
      goBack,
      trainLevelList,
      organizerList,
      add,
      handlerDel,
    };
  },
  components: {
    headers,
    trainItem,
  },
};
</script>
<style lang="less" scoped>
:deep(.van-field__control--custom) {
  display: block;
}
.radioFlex :deep(.van-field__control--custom) {
  display: flex;
}
.d_xm {
  position: relative;
  height: 100%;
}
.wrap {
  height: 100%;
}
.addc {
  margin: 0.26667rem;
  display: flex;
  justify-content: flex-end;
}
.add {
  // position: absolute;
  // bottom: 0;
  // left: 0;
  // width: 100%;
  background: #fe8784;
  color: #fff;
}
</style>
